import { Component, OnInit } from '@angular/core';
import { FastAPIService, News } from '../service/fast-api.service';
import { Subscription, lastValueFrom } from 'rxjs';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';

@Component({
  selector: 'app-analysis-page',
  templateUrl: './analysis-page.component.html',
  styleUrls: ['./analysis-page.component.scss']
})
export class AnalysisPageComponent implements OnInit{
  loading: boolean = true;
  results: News[] = [];
  id: string | null = "";

  routerSubscribe: Subscription;

  constructor(private fastService: FastAPIService, private route: ActivatedRoute, private router: Router) {
    this.routerSubscribe = this.router.events.subscribe((event) => {
      if(event instanceof NavigationEnd && event.url.split(';')[0] == '/analysis') {
        this.reloadData();
      }
    })
  }

  async ngOnInit(): Promise<void> {
    //Called after the constructor, initializing input properties, and the first call to ngOnChanges.
    //Add 'implements OnInit' to the class.
    //await this.reloadData();
  }

  ngOnDestroy(): void {
    //Called once, before the instance is destroyed.
    //Add 'implements OnDestroy' to the class.
    this.routerSubscribe.unsubscribe();
  }

  async reloadData() {
    this.loading = true;
    this.id = this.route.snapshot.paramMap.get('id');
    if(this.id) {
      await this.getResults(this.id);
    }
    this.loading = true;
  }

  async getResults(id: string) {
    // const response = await lastValueFrom(this.fastService.getAnalysisData(id));
    // console.log(response);
  }

  onResultClick(result: News) {
    this.router.navigate(['/analysis-display', { topic: result.Topic_OD, image: result.Picture_URL_OD, detail: result.Detail_OD }])
  }
}
